// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__1vvF0","visibleHandle":"Handle_visibleHandle__PACdg","dragged":"Handle_dragged__3w0UX"};